module.exports = __webpack_public_path__ + "img/Nutech00.50087317.png";